module.exports = __webpack_public_path__ + "static/media/2-Go-Outside.d8bebd00.svg";